module.exports = __webpack_public_path__ + "static/media/sideimg.b76838d2.png";